import React from 'react';
import {
  Box,
  Button,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  CircularProgress,
} from '@mui/material';
import { maskEmail, maskPhone } from '../../../../system/preview';
import { DeliverySelectorProps } from '../types';

const DeliverySelector: React.FC<DeliverySelectorProps> = ({
  report,
  selected,
  onChange,
  onSend,
  isLoading,
}) => {
  const hasPhone = Boolean(report.phone);

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Verify Your Identity
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        To protect your listing data, we require additional verification. Once
        you receive the code, enter it on this page to preview your listing's
        information.
      </Typography>

      <RadioGroup
        value={selected}
        onChange={(e) => onChange(e.target.value as 'email' | 'sms')}
      >
        <FormControlLabel
          value="email"
          control={<Radio />}
          label={`Email to ${maskEmail(report.email)}`}
        />
        {hasPhone && (
          <FormControlLabel
            value="sms"
            control={<Radio />}
            label={`Text to ${maskPhone(report.phone!)}`}
          />
        )}
      </RadioGroup>

      <Button
        variant="contained"
        color="primary"
        onClick={onSend}
        disabled={isLoading}
        sx={{ mt: 3 }}
        fullWidth
      >
        {isLoading ? <CircularProgress size={24} /> : 'Send Code'}
      </Button>
    </Box>
  );
};

export default React.memo(DeliverySelector);
